import React from 'react'
import PropTypes from 'prop-types'

import AppStore from '../../../store/AppStore'
import OSM from '../../../utils/mapUtils/layers/OSM'
import OlMap from '../../../utils/mapUtils/Map'
import HomeAction from '../../../home/actions/HomeAction'
import i18n from 'simple-react-i18n'
import AdministrationAction from '../../actions/AdministrationAction'
import DtoUser from '../../../home/dto/DtoUser'
import { connect } from 'react-redux'
import { getDefaultMapCenter, getDefaultZoom } from '../../../utils/ApplicationUtils'
import ActionComponent from '../../../components/ActionComponent'
import UUID from 'uuid'
import TextField from '@material-ui/core/TextField'

class MapInformationsPanel extends ActionComponent {

	constructor(props) {
		super(props)
		this.state = {
			latitude: this.props.user.latitude,
			longitude: this.props.user.longitude,
			zoom: this.props.user.zoom,
			layers: [OSM()],
			mapConf: {
				size: 600,
				center: getDefaultMapCenter(this.props.user),
				zoom: getDefaultZoom(this.props.user)
			}
		}
	}


	componentWillMount() {
		AppStore.dispatch(HomeAction.setTitle(i18n.map))
	}

	componentWillReceiveProps(nextprops) {
		this.setState({
			latitude: nextprops.user.latitude,
			longitude: nextprops.user.longitude,
			zoom: nextprops.user.zoom,
			mapConf: {
				size: 600,
				center: getDefaultMapCenter(nextprops.user),
				zoom: getDefaultZoom(nextprops.user)
			}
		})
	}

	onSubmit = () => {
		const user = Object.assign({}, this.props.user, {
			latitude: this.state.latitude.toString(),
			longitude: this.state.longitude.toString(),
			zoom: this.state.zoom.toString()
		})
		AppStore.dispatch(AdministrationAction.updateUser(this.props.user.login, user))
	}
	onTodoChange = (key, event) => {
		const user = {}
		user[key] = event.target.value
		this.setState(user)
	}
	getEvent = (point, zoom) => {
		this.setState({
			longitude: point[1],
			latitude: point[0],
			zoom: zoom.toFixed(0),
			mapConf: {
				center: [point[0], point[1]],
				zoom: zoom.toFixed(0)
			}
		})
	}

	render() {
		return (
			<div className='row card'>
				<form className='col s12' onSubmit={ this.onSubmit }>
					<div className='row'>
						<div className='col s4'>
							<TextField
								fullWidth
								type={ 'text' }
								id={ UUID.v4() }
								value={ this.state.longitude }
								floatingLabelText={ i18n.longitude }
								onChange={ (e) => this.handleChange('longitude', e) }
							/>
						</div>
						<div className='col s4'>
							<TextField
								fullWidth
								type={ 'text' }
								id={ UUID.v4() }
								value={ this.state.latitude }
								floatingLabelText={ i18n.latitude }
								onChange={ (e) => this.handleChange('latitude', e) }
							/>
						</div>
						<div className='col s4'>
							<TextField
								fullWidth
								type={ 'number' }
								id={ UUID.v4() }
								value={ this.state.zoom }
								floatingLabelText={ i18n.zoom }
								onChange={ (e) => this.onTodoChange('zoom', e) }
							/>
						</div>
					</div>
					<div className='row'>
						<div className='col s12'>
							<OlMap mapConf={ this.state.mapConf } layers={ this.state.layers } event={ this.getEvent }/>
						</div>
					</div>
				</form>
			</div>
		)
	}

	componentDidMount() {
		this.setAction([
			{
				fn: () => this.onSubmit(),
				icon: 'save'
			}
		])
	}

}

MapInformationsPanel.propTypes = {
	user: PropTypes.objectOf(DtoUser)
}

const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user
	}
}

export default connect(mapStateToProps)(MapInformationsPanel)




// WEBPACK FOOTER //
// ./src/administration/components/mapInformations/MapInformationsPanel.js